import { ProductsTableColumnsIntl } from 'types/i18n';

export const productsTableColumnsIntl: ProductsTableColumnsIntl = {
  id: 'id',
  name: 'Название',
  createdAt: 'Дата создания',
  actualCost: 'Цена в мес',
};
